import React from 'react'
import { AreaChart, BarChart, DonutChart, LineChart } from '../../components/Charts/Charts';
import '../../components/Charts/Charts.css'
export default function Monitoring() {
    const lineData = [
        { x: "Pzt", y: 12 },
        { x: "Sal", y: 18 },
        { x: "Çar", y: 10 },
        { x: "Per", y: 22 },
        { x: "Cum", y: 19 },
        { x: "Cmt", y: 25 },
        { x: "Paz", y: 16 },
    ];

    const areaData = [
        { x: "Hafta 1", y: 120 },
        { x: "Hafta 2", y: 180 },
        { x: "Hafta 3", y: 160 },
        { x: "Hafta 4", y: 210 },
    ];

    const barData = [
        { label: "Ocak", value: 4200 },
        { label: "Şub", value: 5100 },
        { label: "Mar", value: 4700 },
        { label: "Nis", value: 6200 },
        { label: "May", value: 5800 },
    ];

    const donutData = [
        { label: "Satıldı", value: 320 },
        { label: "İade", value: 24 },
        { label: "Rezerve", value: 75 },
        { label: "Stok", value: 110 },
    ];

    const money = (v) =>
        new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 }).format(v) + " ₺";

    return (
        <div className="charts-demo-grid">
            <div>
                <h3 style={{ color: "var(--title-color)" }}>Günlük Ziyaret (Line)</h3>
                <LineChart data={lineData} width={640} height={300} showDots smooth />
            </div>

            <div>
                <h3 style={{ color: "var(--title-color)" }}>Aylık Gelir (Bar)</h3>
                <BarChart data={barData} width={640} height={320} valueFormatter={money} />
            </div>

            <div>
                <h3 style={{ color: "var(--title-color)" }}>Haftalık Toplam (Area)</h3>
                <AreaChart data={areaData} width={640} height={330} />
            </div>

            <div>
                <h3 style={{ color: "var(--title-color)" }}>Envanter Durumu (Donut)</h3>
                <DonutChart
                    data={donutData}
                    width={480}
                    height={320}
                    innerRadiusRatio={0.64}
                    valueFormatter={(v) => new Intl.NumberFormat("tr-TR").format(v)}
                />
            </div>
        </div>
    );
}
